/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateResellerInvoiceOverviews200ResponseResellersInner } from './CreateResellerInvoiceOverviews200ResponseResellersInner';
import {
    CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSON,
    CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSONTyped,
    CreateResellerInvoiceOverviews200ResponseResellersInnerToJSON,
    CreateResellerInvoiceOverviews200ResponseResellersInnerToJSONTyped,
} from './CreateResellerInvoiceOverviews200ResponseResellersInner';
import type { CreateResellerInvoiceOverviews200ResponseFailuresInner } from './CreateResellerInvoiceOverviews200ResponseFailuresInner';
import {
    CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSON,
    CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSONTyped,
    CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSON,
    CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSONTyped,
} from './CreateResellerInvoiceOverviews200ResponseFailuresInner';

/**
 * 
 * @export
 * @interface CreateResellerInvoiceOverviews200Response
 */
export interface CreateResellerInvoiceOverviews200Response {
    /**
     * 
     */
    success?: boolean;
    /**
     * 
     */
    billingPeriod?: string;
    /**
     * 
     */
    resellersProcessed?: number;
    /**
     * 
     */
    resellers?: Array<CreateResellerInvoiceOverviews200ResponseResellersInner>;
    /**
     * 
     */
    failures?: Array<CreateResellerInvoiceOverviews200ResponseFailuresInner>;
}

/**
 * Check if a given object implements the CreateResellerInvoiceOverviews200Response interface.
 */
export function instanceOfCreateResellerInvoiceOverviews200Response(value: object): value is CreateResellerInvoiceOverviews200Response {
    return true;
}

export function CreateResellerInvoiceOverviews200ResponseFromJSON(json: any): CreateResellerInvoiceOverviews200Response {
    return CreateResellerInvoiceOverviews200ResponseFromJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResellerInvoiceOverviews200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'billingPeriod': json['billingPeriod'] == null ? undefined : json['billingPeriod'],
        'resellersProcessed': json['resellersProcessed'] == null ? undefined : json['resellersProcessed'],
        'resellers': json['resellers'] == null ? undefined : ((json['resellers'] as Array<any>).map(CreateResellerInvoiceOverviews200ResponseResellersInnerFromJSON)),
        'failures': json['failures'] == null ? undefined : ((json['failures'] as Array<any>).map(CreateResellerInvoiceOverviews200ResponseFailuresInnerFromJSON)),
    };
}

export function CreateResellerInvoiceOverviews200ResponseToJSON(json: any): CreateResellerInvoiceOverviews200Response {
    return CreateResellerInvoiceOverviews200ResponseToJSONTyped(json, false);
}

export function CreateResellerInvoiceOverviews200ResponseToJSONTyped(value?: CreateResellerInvoiceOverviews200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'billingPeriod': value['billingPeriod'],
        'resellersProcessed': value['resellersProcessed'],
        'resellers': value['resellers'] == null ? undefined : ((value['resellers'] as Array<any>).map(CreateResellerInvoiceOverviews200ResponseResellersInnerToJSON)),
        'failures': value['failures'] == null ? undefined : ((value['failures'] as Array<any>).map(CreateResellerInvoiceOverviews200ResponseFailuresInnerToJSON)),
    };
}

